import { Avatar, Space, Typography, Tooltip } from 'antd';
import { LogoutOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { format, parseISO, isSameDay } from 'date-fns';
import CustomButton from '@/common/CustomButton';
import CustomModal from '@/common/CustomModal';
import { updateUserLeaveStatus } from '../redux/slice';
import styles from '../index.module.less';

const { Text } = Typography;

export default function LeavesModal({
  visible,
  onClose,
  membersOnLeave = [],
  onSuccess
}) {
  const dispatch = useDispatch();

  const handleClose = () => {
    onClose?.();
  };

  const handleRevokeLeave = (member) => {
    dispatch(
      updateUserLeaveStatus({
        id: Number(member.id),
        cancel_leave: true
      })
    ).then((res) => {
      if (res?.payload?.success) {
        onSuccess?.();
      }
    });
  };

  const formatLeaveDate = (member) => {
    if (!member.leave_start_date || !member.leave_end_date) return '—';
    const start = parseISO(member.leave_start_date);
    const end = parseISO(member.leave_end_date);
    const startStr = format(start, 'dd MMM');
    const endStr = format(end, 'dd MMM');
    return isSameDay(start, end) ? startStr : `${startStr} - ${endStr}`;
  };

  return (
    <CustomModal
      visible={!!visible}
      footer={null}
      className={`!w-full sm:!w-[35%] md:!w-[30%] lg:!w-[25%] xl:!w-[30%] ${styles.customModal}`}
      closable={false}
      centered
    >
      <h3 className={styles.mainTitle} style={{ fontWeight: 'bold' }}>
        Members on Leave
      </h3>

      <div
        className="overflow-y-auto"
        style={{ maxHeight: '60vh', marginTop: '1rem' }}
      >
        {!membersOnLeave?.length ? (
          <Text
            type="secondary"
            className={styles.secondaryText}
            style={{
              display: 'flex',
              justifyContent: 'center',
              padding: '24px 0'
            }}
          >
            No member on leave
          </Text>
        ) : (
          membersOnLeave.map((member) => (
            <div key={member.id} className="mb-2">
              <div
                style={{
                  padding: '12px 12px',
                  backgroundColor: '#fff',
                  border: '1px solid #f0f0f0',
                  borderRadius: '4px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gap: '12px'
                }}
              >
                <Space>
                  <Avatar src={member.avatar}>
                    {member.name
                      .split(' ')
                      .map((word) => word[0])
                      .join('')}
                  </Avatar>
                  <Text strong>{member.name}</Text>
                </Space>
                <Space size={8} style={{ alignItems: 'center' }}>
                  <Text
                    type="secondary"
                    className={styles.secondaryText}
                    style={{ color: '#64748b', fontSize: '12px' }}
                  >
                    <Text
                      type="secondary"
                      className={styles.secondaryText}
                      style={{ color: '#64748b', fontSize: '12px' }}
                    >
                      Date:{' '}
                    </Text>
                    {formatLeaveDate(member)}
                  </Text>
                  <Tooltip title="Revoke leave">
                    <span
                      role="button"
                      tabIndex={0}
                      className="p-1 rounded hover:bg-[#00000004] cursor-pointer inline-flex items-center justify-center"
                      onClick={() => handleRevokeLeave(member)}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                          handleRevokeLeave(member);
                        }
                      }}
                    >
                      <LogoutOutlined
                        style={{
                          color: 'gray',
                          transform: 'scaleX(-1)'
                        }}
                      />
                    </span>
                  </Tooltip>
                </Space>
              </div>
            </div>
          ))
        )}
      </div>

      <div
        style={{ marginTop: '20px', display: 'flex', justifyContent: 'center' }}
      >
        <CustomButton
          className={styles.inwardButton}
          onClick={handleClose}
          type="primary"
          ghost
        >
          Close
        </CustomButton>
      </div>
    </CustomModal>
  );
}
